import _omit from 'lodash/omit';
import { RichTextNode } from 'pages/Homepage/typings';

const HEADING_TYPE_KEYS = ['heading_one', 'heading_two', 'heading_three'];

// (note - pearl) This helper is being used for default rich text content,
// as we do not allow headings in there and will transform them into regular text
function sanitizeHeadingNodes(childrenToTransform: Array<RichTextNode>) {
  const serialize = (node: RichTextNode): RichTextNode => {
    if (node.children) {
      node.children.map(n => serialize(n));
    }

    if (node.type && HEADING_TYPE_KEYS.includes(node.type)) {
      return _omit(node, 'type');
    }

    return node;
  };

  return childrenToTransform.map(c => serialize(c));
}

export default sanitizeHeadingNodes;
